import React from 'react'

export const READY = "변경사항 저장"
export const CAN_SUBMIT = "변경사항 저장"
export const DOING = <span className="ico_blog">저장중</span>
export const DONE = [
	'저장 완료',
	<span key="1" className="ico_blog" />
]
